import RequestAcceptedModal from './RequestAcceptedModal';

export default RequestAcceptedModal;
